import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import { FAQs, PaymentStatus } from "./Component/InfoPages";
import {
  AcceptableUsePolicy,
  AccessibilityPolicy,
  ChildrenPrivacyPolicy,
  ComplaintsPolicy,
  CookiePolicy,
  IntellectualPropertyPolicy,
  LegalNotice,
  OrdersPolicy,
  PaymentsPolicy,
  PolicyCentre,
  PricingTaxPolicy,
  ProductSafetyPolicy,
  PromotionsPolicy,
  ReviewsPolicy,
  SecurityPolicy,
  WarrantyPolicy,
} from "./Component/PolicyPages";

function App() {
  return (
    <CartProvider>
      <Router
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <a className="skip-link" href="#main-content">
          Skip to main content
        </a>
        <Header />
        <div id="main-content">
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/policies" element={<PolicyCentre />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/orders-cancellations" element={<OrdersPolicy />} />
            <Route path="/payments-policy" element={<PaymentsPolicy />} />
            <Route path="/pricing-tax-policy" element={<PricingTaxPolicy />} />
            <Route path="/warranty-policy" element={<WarrantyPolicy />} />
            <Route path="/product-safety" element={<ProductSafetyPolicy />} />
            <Route path="/promotions-policy" element={<PromotionsPolicy />} />
            <Route path="/reviews-policy" element={<ReviewsPolicy />} />
            <Route path="/acceptable-use" element={<AcceptableUsePolicy />} />
            <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
            <Route path="/accessibility" element={<AccessibilityPolicy />} />
            <Route path="/security-policy" element={<SecurityPolicy />} />
            <Route path="/complaints-policy" element={<ComplaintsPolicy />} />
            <Route path="/children-privacy" element={<ChildrenPrivacyPolicy />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/payment" element={<PaymentStatus />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
